// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2QTGH","shimmer":"styles_shimmer__2LmFV"};